// extracted by mini-css-extract-plugin
export var option = "_47-0";
export var optionCard = "_47-f";
export var optionContent = "_47-g";
export var optionIcon = "_47-i";
export var optionIconBox = "_47-h";
export var optionLabel = "_47-j";
export var optionPill = "_47-m";
export var optionPillBadge = "_47-p";
export var optionPillIcon = "_47-n";
export var optionPillLabel = "_47-o";
export var optionRadio = "_47-k";
export var optionRadioInner = "_47-l";
export var optionReveal = "_47-2";
export var optionRevealDelay0 = "_47-3";
export var optionRevealDelay1 = "_47-4";
export var optionRevealDelay10 = "_47-d";
export var optionRevealDelay11 = "_47-e";
export var optionRevealDelay2 = "_47-5";
export var optionRevealDelay3 = "_47-6";
export var optionRevealDelay4 = "_47-7";
export var optionRevealDelay5 = "_47-8";
export var optionRevealDelay6 = "_47-9";
export var optionRevealDelay7 = "_47-a";
export var optionRevealDelay8 = "_47-b";
export var optionRevealDelay9 = "_47-c";
export var optionSelected = "_47-1";